import { window } from '@wix/photography-client-lib';
export function replaceWindowElement(_ref) {
  var type = _ref.type,
      id = _ref.id,
      attributes = _ref.attributes,
      innerHTML = _ref.innerHTML,
      parentElement = _ref.parentElement;
  var removedElement = window.document.getElementById(id);

  if (removedElement) {
    var parent = removedElement.parentNode;
    parent.removeChild(removedElement);
  }

  var addedElement = window.document.createElement(type);
  addedElement.setAttribute('id', id);
  Object.keys(attributes).forEach(function (key) {
    return addedElement.setAttribute(key, attributes[key]);
  });

  if (innerHTML) {
    addedElement.innerHTML = innerHTML;
  }

  parentElement.appendChild(addedElement);
}